import React from 'react';
import PropTypes from 'prop-types';
import { useMappedRows } from './hooks';
// eslint-disable-next-line
import AdminTableRow from './tr';
import { StyledEmptyTr } from './styled';

function AdminTableDropdownRows({
    isExpanded,
    rowLevel,
    dropdownRows,
    columnsSettings,
    parentRow,
    requestsSettings,
    withColoredCircles,
    onClickViewRow,
    onClickEditRow,
    onClickDeleteRow,
    onClickSendRow,
}) {
    const mappedRows = useMappedRows(dropdownRows, requestsSettings, rowLevel);
    const hasRows = mappedRows && mappedRows.length;

    if (isExpanded && hasRows) {
        return (
            <>
                {mappedRows.map((item, index) => {
                    const key = `tr-dropdown-${index}`;

                    return (
                        <AdminTableRow
                            key={key}
                            index={index}
                            row={item}
                            parentRow={parentRow}
                            rowLevel={rowLevel}
                            columnsSettings={columnsSettings}
                            requestsSettings={requestsSettings}
                            withColoredCircles={withColoredCircles}
                            onClickViewRow={onClickViewRow}
                            onClickEditRow={onClickEditRow}
                            onClickDeleteRow={onClickDeleteRow}
                            onClickSendRow={onClickSendRow}
                        />
                    );
                })}
            </>
        );
    }

    if (isExpanded && !hasRows) {
        return (
            <StyledEmptyTr>
                <td colSpan="100%">No se encontraron datos.</td>
            </StyledEmptyTr>
        );
    }

    return <></>;
}

AdminTableDropdownRows.propTypes = {
    isExpanded: PropTypes.bool,
    rowLevel: PropTypes.number,
    dropdownRows: PropTypes.array,
    withColoredCircles: PropTypes.bool,
    onClickViewRow: PropTypes.func,
    onClickEditRow: PropTypes.func,
    onClickDeleteRow: PropTypes.func,
    onClickSendRow: PropTypes.func,
    columnsSettings: PropTypes.any,
    requestsSettings: PropTypes.any,
    parentRow: PropTypes.any,
};

AdminTableDropdownRows.defaultProps = {
    isExpanded: undefined,
    rowLevel: 0,
    dropdownRows: undefined,
    withColoredCircles: undefined,
    onClickViewRow: () => {},
    onClickEditRow: () => {},
    onClickDeleteRow: () => {},
    onClickSendRow: () => {},
    columnsSettings: undefined,
    requestsSettings: undefined,
    parentRow: undefined,
};

export default AdminTableDropdownRows;
